// src/pages/Login.jsx
import React, { useState } from 'react';
import { db } from '../services/firebase';
import { doc, getDoc } from 'firebase/firestore';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import bcrypt from 'bcryptjs';
import { useOperator } from '../contexts/OperaotrContext'; // 🔸 Fixed typo: "OperaotrContext" → "OperatorContext"

const Login = () => {
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const nav = useNavigate();
  const { updateOperator } = useOperator(); // ✅ Get the updater function

  const handleLogin = async () => {
    localStorage.clear();
    if (mobile.length !== 10 || isNaN(mobile)) {
      alert('Please enter a valid 10-digit mobile number');
      return;
    }
    if (password.trim() === '') {
      alert('Please enter your password');
      return;
    }

    try {
      const docRef = doc(db, 'operator', mobile);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        alert('Operator not found');
        return;
      }

      const data = docSnap.data();
      console.log('Operator data:', data);

      // Verify password
      const isMatch = await bcrypt.compare(password, data.passwordHash);
      if (!isMatch) {
        alert('Incorrect password');
        return;
      }

      const OperatorId = data.operatorId;

      // Fetch profile to determine next route
      const operatorProfileRef = doc(db, 'profile', OperatorId);
      const profileSnap = await getDoc(operatorProfileRef);
      const profileData = profileSnap.exists() ? profileSnap.data() : {};

      const operatorRegistrationRef = doc(db, 'operatorregistrations', OperatorId);
      const operatorRegistrationSnap = await getDoc(operatorRegistrationRef);
      const operatorRegistrationData = operatorRegistrationSnap.exists()
        ? operatorRegistrationSnap.data()
        : {};
      const state = operatorRegistrationData.contactState || operatorRegistrationData.state || null;
      const district = operatorRegistrationData.contactDistrict || operatorRegistrationData.district || null;

      // ✅ Save to Context
      updateOperator({
        OperatorId,
        mobile, // plain 10-digit string (no +91)
        state,
        district,
      });

      // ✅ Save to localStorage
      localStorage.setItem('operatorId', OperatorId);
      localStorage.setItem('operatorMobile', mobile);
      if (state) localStorage.setItem('operatorState', state);
      if (district) localStorage.setItem('operatorDistrict', district);

      console.log('Profile data:', profileData);

      // Redirect based on registration status
      if (!profileData.OperatorRegistration) {
        nav('/operatorRegistration');
      } else if (!profileData.SegmentRegistration) {
        nav('/segmentRegistration');
      } else {
        nav('/homepage');
      }
    } catch (err) {
      console.error('Login error:', err);
      alert('Login failed. Please try again.');
    }
  };

  return (
    <div className="login-wrapper">
      <h1 className="title">JMI</h1>
      <p className="subtitle">Operator Desk</p>

      <div className="login-box">
        <h2>Operator Login</h2>

        <label>Mobile Number</label>
        <input
          type="tel"
          maxLength="10"
          placeholder="Enter Mobile Number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value.replace(/\D/g, ''))}
        />

        <label>Password</label>
        <input
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button className="login-btn" onClick={handleLogin}>
          Login
        </button>
        <p className="forgot" onClick={() => nav('/forgotPassword')}>
          Forgot Password?
        </p>
      </div>

      <p className="register-link">
        Don't have an account?{' '}
        <span onClick={() => nav('/register')} >
          Register now
        </span>
      </p>

      <p className="support">
        <img src="/whatsapp.svg" alt="whatsapp" className="whatsapp-icon" />
        <span onClick={() => window.open("https://wa.me/918917412728", "_blank")}> Need help? </span>Contact Support
      </p>
    </div>
  );
};

export default Login;
